/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogPropertyTextSummary } from './CatalogPropertyTextSummary';
import type { ConversationChannel } from './ConversationChannel';
/**
 * Canonical message identity and presentation context for notification consumers.
 */
export type NotificationMessageContext = {
    /**
     * Stable integrations Message identifier used to deduplicate deliveries.
     */
    id: string;
    /**
     * Human-readable sender name, when available from the existing CRM context.
     */
    senderName?: string;
    /**
     * Messaging channel, independent of the notification delivery channel.
     */
    channel: ConversationChannel;
    /**
     * Original message timestamp, used to avoid replaying old alerts on resume.
     */
    createdAt: string;
    /**
     * Preview classification; media previews never expose attachment URLs.
     */
    kind: NotificationMessageContext.kind;
    /**
     * Property identifier already available in the conversation context.
     */
    propertyId?: number;
    /**
     * Optional catalog summary authorized for this notification's recipient.
     */
    property?: CatalogPropertyTextSummary;
};
export namespace NotificationMessageContext {
    /**
     * Preview classification; media previews never expose attachment URLs.
     */
    export enum kind {
        TEXT = 'text',
        IMAGE = 'image',
        VIDEO = 'video',
        AUDIO = 'audio',
        FILE = 'file',
    }
}

